import React from "react";
import { useTranslate } from "@refinedev/core";
import {
  AppstoreOutlined,
  ExperimentOutlined,
  FilterOutlined,
  TagsOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import { TabHub } from "../../components/TabHub";
import { ProductList } from "../products/list";
import { PricingPlanList } from "../pricing-plans/list";
import { CreditPackList } from "../credit-packs/list";
import { ProductRulesList } from "../product-rules";
import { ProductRuleTesterPage } from "../product-rules/test";

/**
 * Catalogue hub — what we sell and for how much.
 *
 * Deliberately top-level rather than under Configuration: these are business
 * records with a weekly-or-faster edit cadence, not tenant configuration.
 */
export const CatalogPage: React.FC = () => {
  const _t = useTranslate();

  return (
    <div className="max-w-7xl mx-auto">
      <TabHub
        title={_t("catalog.catalog", "Catalog")}
        subtitle={_t("catalog.subtitle", "")}
        items={[
          {
            key: "products",
            label: _t("catalog.tabs.products", "Products"),
            icon: <AppstoreOutlined />,
            children: <ProductList hideHeader />,
          },

          {
            key: "product-rules",
            label: _t("catalog.tabs.productRules", "Product rules"),
            icon: <FilterOutlined />,
            children: <ProductRulesList hideHeader />,
          },
          {
            key: "plans",
            label: _t("catalog.tabs.plans", "Pricing plans"),
            icon: <TagsOutlined />,
            children: <PricingPlanList hideHeader />,
          },
          {
            key: "credit-packs",
            label: _t("catalog.tabs.creditPacks", "Credit packs"),
            icon: <WalletOutlined />,
            children: <CreditPackList hideHeader />,
          },/*
          {
            key: "rule-tester",
            label: _t("catalog.tabs.ruleTester", "Rule tester"),
            icon: <ExperimentOutlined />,
            children: <ProductRuleTesterPage hideHeader />,
          },*/
        ]}
      />
    </div>
  );
};
